import { ExtractProps, withTranslations } from 'hooks/useTranslations'
import { graphql, useStaticQuery } from 'gatsby'

declare global {
  interface Snippets {
    'molecules-Share': {
      copy_link: void
      copy_link_confirmation: void
      modal_headline: void
      modal_info_text: void
      modal_close: void
      share_by_whatsapp: void
      share_by_email: void
      share_by_email_subject: void
      share_button_label: void
      BFSG_share_product: void
      BFSG_copy_link_to_clipboard: void
    }
  }
}

export default <C extends React.FC<ExtractProps<C>>>(Component: C) =>
  withTranslations(Component, () =>
    useStaticQuery(graphql`
      query molecules_Share_translations {
        copy_link: snippet(group: "molecules-Share", name: "copy_link")
        copy_link_confirmation: snippet(
          group: "molecules-Share"
          name: "copy_link_confirmation"
        )
        modal_headline: snippet(
          group: "molecules-Share"
          name: "modal_headline"
        )
        modal_info_text: snippet(
          group: "molecules-Share"
          name: "modal_info_text"
        )
        modal_close: snippet(group: "molecules-Share", name: "modal_close")
        share_by_whatsapp: snippet(
          group: "molecules-Share"
          name: "share_by_whatsapp"
        )
        share_by_email: snippet(
          group: "molecules-Share"
          name: "share_by_email"
        )
        share_by_email_subject: snippet(
          group: "molecules-Share"
          name: "share_by_email_subject"
        )
        share_button_label: snippet(
          group: "molecules-Share"
          name: "share_button_label"
        )
        BFSG_share_product: snippet(
          group: "molecules-Share"
          name: "BFSG_share_product"
        )
        BFSG_copy_link_to_clipboard: snippet(
          group: "molecules-Share"
          name: "BFSG_copy_link_to_clipboard"
        )
      }
    `)
  )
